import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export type Attribute = {
  displayName: string;
  value: any;
};

export interface Hierarchy {
  id: string;
  name: string;
  typename: string;
  fullid: string;
  symbol: string;
  children: Hierarchy[];
  parentid?: string;
  parentPath?: string;
  roles: string[];
  attributes: Record<string, Attribute>;
}

export interface MapViewState {
  hierarchy: Hierarchy;
  error?: ErrorObject;
}

const initialState = {
  hierarchy: {
    id: '',
    name: '',
    typename: '',
    fullid: '',
    symbol: '',
    description: '',
    roles: [''],
    children: [],
    attributes: {}
  }
} as MapViewState;

export default initialState;
